export interface OrbPosition {
  x: number;
  y: number;
}

export interface OrbViewport {
  w: number;
  h: number;
}

export const ORB_SIZE = 56;
export const ORB_MARGIN = 16;
export const MOBILE_ORB_BREAKPOINT = 1024;
export const MOBILE_ORB_MARGIN = 12;

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function isMobileOrbViewport(viewport: OrbViewport): boolean {
  return viewport.w < MOBILE_ORB_BREAKPOINT;
}

/**
 * Keeps the mobile orb in Layout's reserved bottom dock. Desktop retains the
 * freely draggable behavior while staying inside the viewport.
 */
export function constrainOrbPosition(position: OrbPosition, viewport: OrbViewport): OrbPosition {
  const mobile = isMobileOrbViewport(viewport);
  const margin = mobile ? MOBILE_ORB_MARGIN : ORB_MARGIN;
  const maxX = Math.max(margin, viewport.w - ORB_SIZE - margin);
  const maxY = Math.max(margin, viewport.h - ORB_SIZE - margin);

  return {
    x: clamp(position.x, margin, maxX),
    y: mobile ? maxY : clamp(position.y, margin, maxY),
  };
}

export function defaultOrbPositionForViewport(viewport: OrbViewport): OrbPosition {
  return constrainOrbPosition({
    x: viewport.w - ORB_SIZE - 24,
    y: viewport.h - ORB_SIZE - 24,
  }, viewport);
}
